/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef, useCallback, useMemo } from "react"
import Header from "../../../../layouts/Header"
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import { PickingContextProvider } from "../../PickingContext"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { TextField, Box, TablePagination, Tooltip, IconButton } from "@mui/material"
import fetchwrapper from "../../../../services/interceptors/fetchwrapper"
import { useQuery } from "@tanstack/react-query"
import normalFormatDate from "../../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../../utils/date/HHMMSSFormatHour"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers"
import DetalleIcon from "../../../../assets/iconos/Detalle.ico"
import { esES } from "@mui/material/locale"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { useNavigate } from "react-router-dom"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import useDebounce from "../../../SolicitudDeIngreso/components/Debounce"
import BackIcon from "../../../../components/BackIcon"

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const CustomTable = ({
  fetchedInfo = [],
  isLoadingInfoError,
  isLoadingInfo,
  isFetchingInfo,
  searchAttempted,
  totalPages,
  onFilterChange,
  onPageChange,
  currentPage,
}) => {
  const navigate = useNavigate()

  const [filters, setFilters] = useState({})
  const [page, setPage] = useState(1)
  const [fechaSolicitud, setFechaSolicitud] = useState(null)
  const [fechaLlegada, setFechaLlegada] = useState(null)

  // Maneja cambios en los filtros de la grilla
  const handleFilterChange = (columnId, value) => {
    onFilterChange(columnId, value)
  }

  useEffect(() => {
    setPage(currentPage) // Sincroniza la página interna con el prop currentPage
  }, [currentPage])

  const handleFechaSolicitud = (newFecha) => {
    setFechaSolicitud(newFecha)
    if (newFecha) {
      handleFilterChange("Fecha_Emision", newFecha.format("YYYY-MM-DD"))
    } else {
      handleFilterChange("Fecha_Emision", "")
    }
  }

  const handleFechaLlegada = (newFecha) => {
    setFechaLlegada(newFecha)
    if (newFecha) {
      handleFilterChange("Fecha_Picking", newFecha.format("YYYY-MM-DD"))
    } else {
      handleFilterChange("Fecha_Picking", "")
    }
  }

  const handlePageChange = useCallback(
    (event, newPage) => {
      setPage(newPage + 1)
      onPageChange(newPage + 1)
    },
    [onPageChange],
  )

  useEffect(() => {
    setPage(page)
  }, [page])

  const columns = useMemo(
    () => [
      {
        accessorKey: "acciones",
        header: "Acciones",
        enableColumnFilter: false,
        size: 150,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  navigate("productos", { state: row.original })
                }}
              >
                <img src={DetalleIcon} alt="Detalle" style={{ width: "30px" }} />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
      {
        accessorKey: "Picking",
        header: "Picking",
        enableEditing: false,
        size: 200,
        Filter: ({ column }) => (
          <TextField
            variant="standard"
            placeholder="Filtrar"
            fullWidth
            InputProps={{ style: { padding: "8px" } }}
            onChange={(e) => handleFilterChange(column.id, e.target.value)}
            sx={{
              width: 100,
              "& .MuiInputBase-input": {
                padding: "8px",
              },
            }}
          />
        ),
      },
      {
        accessorKey: "Fecha_Emision",
        header: "Fecha Emisión",
        enableEditing: false,
        size: 200,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={fechaSolicitud}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  variant: "filled",
                  sx: {
                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                  },
                },
              }}
              onChange={handleFechaSolicitud}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </LocalizationProvider>
        ),
      },
      {
        accessorKey: "Hora_Emision",
        header: "Hora Emisión",
        enableEditing: false,
        size: 120,
        enableColumnFilter: false,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return cellValue
        },
      },
      {
        accessorKey: "Comentario_Picking",
        header: "Comentario",
        enableEditing: false,
        size: 120,
        Filter: ({ column }) => (
          <TextField
            variant="standard"
            placeholder="Filtrar"
            fullWidth
            InputProps={{ style: { padding: "8px" } }}
            onChange={(e) => handleFilterChange(column.id, e.target.value)}
            sx={{
              width: 100,
              "& .MuiInputBase-input": {
                padding: "8px",
              },
            }}
          />
        ),
      },
      {
        accessorKey: "Fecha_Picking",
        header: "Fecha Picking",
        enableEditing: false,
        size: 120,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return normalFormatDate(cellValue)
        },
        Filter: ({ column }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={fechaLlegada}
              format="DD/MM/YYYY"
              slotProps={{
                textField: {
                  variant: "filled",
                  sx: {
                    "& .MuiFilledInput-root": {
                      backgroundColor: "transparent",
                    },
                  },
                },
              }}
              onChange={handleFechaLlegada}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </LocalizationProvider>
        ),
      },
      {
        accessorKey: "Hora_Picking",
        header: "Hora Picking",
        enableColumnFilter: false,
        size: 120,
        Cell: ({ cell }) => {
          const cellValue = cell.getValue()
          return cellValue
        },
      },
      {
        accessorKey: "Tipo_Picking",
        header: "Tipo",
        enableEditing: false,
        size: 120,
        Filter: ({ column }) => (
          <TextField
            variant="standard"
            placeholder="Filtrar"
            fullWidth
            InputProps={{ style: { padding: "8px" } }}
            onChange={(e) => handleFilterChange(column.id, e.target.value)}
            sx={{
              width: 100,
              "& .MuiInputBase-input": {
                padding: "8px",
              },
            }}
          />
        ),
      },
      {
        accessorKey: "Estado",
        header: "Estado",
        enableEditing: false,
        size: 120,
        Filter: ({ column }) => (
          <TextField
            variant="standard"
            placeholder="Filtrar"
            fullWidth
            InputProps={{ style: { padding: "8px" } }}
            onChange={(e) => handleFilterChange(column.id, e.target.value)}
            sx={{
              width: 100,
              "& .MuiInputBase-input": {
                padding: "8px",
              },
            }}
          />
        ),
      },
    ],
    [fechaSolicitud, fechaLlegada],
  )

  const table = useMaterialReactTable({
    columns,
    data: fetchedInfo,
    enableEditing: false,
    enableRowActions: false,
    localization: { ...MRT_Localization_ES },
    initialState: {
      showColumnFilters: true,
    },
    getRowId: (row) => row.formcodigo,
    muiToolbarAlertBannerProps:
      searchAttempted && !isLoadingInfo && fetchedInfo.length === 0 && !isFetchingInfo
        ? {
            color: "info",
            children: "No se encontraron solicitudes",
          }
        : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    enablePagination: false,
    renderToolbarInternalActions: ({ table }) => <Box></Box>,
    renderBottomToolbarCustomActions: () => (
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", padding: "0.5rem" }}>
        <TablePagination
          rowsPerPageOptions={[10]}
          component="div"
          count={totalPages}
          rowsPerPage={10}
          page={page - 1}
          onPageChange={handlePageChange}
        />
      </Box>
    ),
    state: {
      isLoading: isLoadingInfo,
      showAlertBanner: isLoadingInfoError,
      showProgressBars: isFetchingInfo,
    },
  })

  return (
    <>
      <MaterialReactTable table={table} />
    </>
  )
}

const GridPickings = ({
  refetch,
  fetchedInfo,
  isLoadingInfo,
  isError,
  isFetchingInfo,
  totalPages,
  onPageChange,
  onFilterChange,
}) => {
  const theme = useTheme()

  // Maneja cambios en los filtros de la grilla
  const handleFilterChange = (columnId, value) => {
    onFilterChange(columnId, value)
  }

  return (
    <div>
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable
          fetchedInfo={fetchedInfo}
          isLoadingInfoError={isError}
          isLoadingInfo={isLoadingInfo}
          isFetchingInfo={isFetchingInfo}
          totalPages={totalPages}
          onPageChange={onPageChange}
          refetch={refetch}
          onFilterChange={handleFilterChange}
        />
      </ThemeProvider>
    </div>
  )
}
const VerPicking = () => {
  // paginación
  const [totalPages, setTotalPages] = useState(1)
  const [page, setPage] = useState(1)
  const [pickingsSugerido, setPickingSugerido] = useState([])

  // filtros
  const [filters, setFilters] = useState({})
  const isFirstRender = useRef(true)
  const debouncedFilters = useDebounce(filters, 500) // ms
  const [searchAttempted, setSearchAttempted] = useState(false)

  // Función para manejar cambios en los filtros de la grilla
  const handleGrillaFilterChange = (columnId, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [columnId]: value,
    }))
  }

  const {
    data: fetchedPickingSugerido = {},
    isError: isLoadingPickingSugeridoError,
    isFetching: isFetchinPickingSugerido,
    isLoading: isLoadingPickingSugerido,
    refetch: refetchPickingSugerido,
  } = useGetPickingSugerido(page)

  function useGetPickingSugerido() {
    return useQuery({
      queryKey: ["PickingSugeridoCreate", page],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({ page, filters }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper("/picking/getPickingSugeridoHelper", options)
        response = await response.json()

        console.log(response.data)
        return response // Asegúrate de devolver todo el objeto response, no solo response.data
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      enabled: true,
    })
  }

  useEffect(() => {
    setPickingSugerido(fetchedPickingSugerido.data)
    setTotalPages(fetchedPickingSugerido.total)
  }, [fetchedPickingSugerido])

  useEffect(() => {
    if (Object.keys(filters).length) {
      console.log("prueba filtrosssss")
      setFilters(filters)
      refetchPickingSugerido(debouncedFilters)
      setPage(1)
    }
  }, [debouncedFilters])

  const onPageChange = (newPage) => {
    setPage(newPage) // Actualiza el estado de la página
  }

  return (
    <PickingContextProvider>
      <ThemeProvider theme={theme}>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <BackIcon />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 30px 30px 30px",
              fontSize: "25px",
            }}
          >
            <b>Crear Picking</b>
          </div>
          <GridPickings
            fetchedInfo={pickingsSugerido}
            isLoadingInfoError={isLoadingPickingSugeridoError}
            isLoadingInfo={isLoadingPickingSugerido}
            isFetchingInfo={isFetchinPickingSugerido}
            searchAttempted={searchAttempted}
            setSolicitudesIngresos={setPickingSugerido}
            refetch={refetchPickingSugerido}
            totalPages={totalPages}
            onPageChange={onPageChange}
            onFilterChange={handleGrillaFilterChange}
          />
        </div>
      </ThemeProvider>
    </PickingContextProvider>
  )
}

export default VerPicking
